/**
 * Lesson guest token: the backend returns it with the lesson data when a shared lesson is played
 * without logging in. It is only used to fetch the Azure speech token for text to speech.
 * It is kept in memory, never in the user token storage, because a user token there means "logged in".
 */
export const LESSON_GUEST_TOKEN_RESPONSE_HEADER = 'vizzle_lesson_token';
export const LESSON_GUEST_TOKEN_REQUEST_HEADER = 'Vizzle-Lesson-Token';
export const SPEECH_TOKEN_URL = '/terminologies/speechtoken';

let lessonGuestToken = null;

export const saveLessonGuestTokenFromHeaders = (headers) => {
  const token = headers ? headers[LESSON_GUEST_TOKEN_RESPONSE_HEADER] : null;
  if (token) {
    lessonGuestToken = token;
  }
};

export const getLessonGuestToken = () => lessonGuestToken;

export const clearLessonGuestToken = () => {
  lessonGuestToken = null;
};

/**
 * Extra headers for the speech token request: the guest token, but only when there is no logged-in user.
 *
 * @param {*} userToken the logged-in user's token, if any
 * @param {*} guestToken the lesson guest token, if any
 */
export const createSpeechTokenRequestHeaders = (userToken, guestToken) => (
  !userToken && guestToken ? { [LESSON_GUEST_TOKEN_REQUEST_HEADER]: guestToken } : {}
);

/**
 * A rejected speech token request means text to speech is unavailable, not that the session expired.
 *
 * @param {*} requestConfig the axios request config
 */
export const isSpeechTokenRequest = (requestConfig) => {
  const url = requestConfig && requestConfig.url;
  return typeof url === 'string' && url.split('?')[0].endsWith(SPEECH_TOKEN_URL);
};
